import { zonesNormalize } from "../zones/index.js";
/**
 * Filter an array x/y based on various criteria x points are expected to be sorted
 * @param data - object containing 2 properties x and y
 * @param options - options
 * @returns filtered array
 */
export function xyFilterX(data, options = {}) {
    const { x, y } = data;
    if (x.length === 0) {
        return {
            x: Array.from(x),
            y: Array.from(y),
        };
    }
    const { from = x[0], to = x.at(-1), zones = [{ from, to }], exclusions = [], } = options;
    // @ts-expect-error -- x.at(-1) returns number | undefined but array is guaranteed non-empty here
    const normalizedZones = zonesNormalize(zones, { from, to, exclusions });
    let currentZoneIndex = 0;
    const newX = [];
    const newY = [];
    let position = 0;
    while (position < x.length) {
        if (x[position] <= normalizedZones[currentZoneIndex].to &&
            x[position] >= normalizedZones[currentZoneIndex].from) {
            newX.push(x[position]);
            newY.push(y[position]);
        }
        else if (x[position] > normalizedZones[currentZoneIndex].to) {
            currentZoneIndex++;
            if (!normalizedZones[currentZoneIndex])
                break;
        }
        position++;
    }
    return {
        x: newX,
        y: newY,
    };
}
//# sourceMappingURL=xyFilterX.js.map